import getChatToken from "app/api/getChatToken";
import putMessage from "app/api/requests/Chat/putMessage";

export const postMessage = (receiverId: number, message: string) => (dispatch: any): any => {
	const token = getChatToken();
	return putMessage(token, {
		receiverId,
		text: message
	})
}
